import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import blink from "./blink.gif";
import "./style.css";

const RosaChatgpt = () => {
  const navigate = useNavigate();
  const userEmail = sessionStorage.getItem("userEmail");

  const [botResponse, setBotResponse] = useState("");
  const [showResponse, setShowResponse] = useState(false);

  const voicePhrases = [
    "Listening for your command...",
    "Adjusting camera focus...",
    "Optimizing video quality...",
    "Analyzing speech clarity...",
  ];

  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const [finishedPhrases, setFinishedPhrases] = useState(false);
  const lastPhraseSpoken = useRef(false);

  const speak = (text, onEnd) => {
    if ("speechSynthesis" in window) {
      const utter = new SpeechSynthesisUtterance(text);
      utter.rate = 1.05;
      utter.pitch = 1.1;
      utter.lang = "en-US";

      utter.onend = () => {
        if (onEnd) onEnd();
      };

      window.speechSynthesis.cancel();
      window.speechSynthesis.speak(utter);
    } else {
      if (onEnd) onEnd();
    }
  };

  useEffect(() => {
    let current = 0;

    speak(voicePhrases[0]);

    const interval = setInterval(() => {
      setFade(false);

      setTimeout(() => {
        current++;

        if (current < voicePhrases.length) {
          setIndex(current);

          speak(voicePhrases[current], () => {
            if (current === voicePhrases.length - 1) {
              lastPhraseSpoken.current = true;
            }
          });
        } else {
          clearInterval(interval);
          setFinishedPhrases(true);
        }

        setFade(true);
      }, 350);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const [mediaRecorder, setMediaRecorder] = useState(null);
  const audioChunks = useRef([]);
  const recordedOnce = useRef(false);
  const micStreamRef = useRef(null);

  const requestMicPermission = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      micStreamRef.current = stream;

      const recorder = new MediaRecorder(stream);

      recorder.ondataavailable = (e) => {
        if (e.data.size > 0) {
          audioChunks.current.push(e.data);
        }
      };

      recorder.onstop = async () => {
        const audioBlob = new Blob(audioChunks.current, { type: "audio/wav" });
        audioChunks.current = [];
        await handleVoiceCommand(audioBlob);
      };

      setMediaRecorder(recorder);
      return stream;
    } catch (err) {
      console.error("Mic permission error:", err);
    }
  };

  useEffect(() => {
    requestMicPermission();
  }, []);

  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const sourceRef = useRef(null);
  const loopRef = useRef(null);

  const RMS_THRESHOLD = 0.02;
  const MIN_SPEAK_DURATION = 150;
  const MAX_RECORDING_MS = 5000;

  const startAmplitudeMonitoring = async () => {
    const stream = micStreamRef.current || (await requestMicPermission());

    if (!audioContextRef.current) {
      audioContextRef.current = new AudioContext();
    }

    if (!analyserRef.current) {
      analyserRef.current = audioContextRef.current.createAnalyser();
      analyserRef.current.fftSize = 2048;
    }

    if (!sourceRef.current) {
      sourceRef.current =
        audioContextRef.current.createMediaStreamSource(stream);
      sourceRef.current.connect(analyserRef.current);
    }

    const analyser = analyserRef.current;
    const data = new Uint8Array(analyser.fftSize);

    let aboveSince = null;

    const check = () => {
      analyser.getByteTimeDomainData(data);

      let sum = 0;
      for (let i = 0; i < data.length; i++) {
        const x = (data[i] - 128) / 128;
        sum += x * x;
      }

      const rms = Math.sqrt(sum / data.length);
      const now = performance.now();

      if (rms >= RMS_THRESHOLD) {
        if (!aboveSince) aboveSince = now;

        if (
          now - aboveSince >= MIN_SPEAK_DURATION &&
          !recordedOnce.current &&
          lastPhraseSpoken.current &&
          mediaRecorder
        ) {
          recordedOnce.current = true;
          audioChunks.current = [];

          mediaRecorder.start();

          setTimeout(() => {
            mediaRecorder.stop();
          }, MAX_RECORDING_MS);

          return;
        }
      } else {
        aboveSince = null;
      }

      loopRef.current = requestAnimationFrame(check);
    };

    loopRef.current = requestAnimationFrame(check);
  };

  useEffect(() => {
    if (mediaRecorder) startAmplitudeMonitoring();
  }, [mediaRecorder]);

  const handleVoiceCommand = async (audioBlob) => {
    try {
      const fd = new FormData();
      fd.append("audio", audioBlob, "voice.wav");
      fd.append("path", `/var/www/myflaskapp/flask_static/${userEmail}`);

      const uploadRes = await fetch(
        "https://www.d-rosa.ai/upload_audio",
        { method: "POST", body: fd }
      );

      const { converted_path } = await uploadRes.json();

      const fd2 = new FormData();
      fd2.append("path", converted_path);

      const textRes = await fetch(
        "https://www.d-rosa.ai/SPEECHTOTXT",
        { method: "POST", body: fd2 }
      );

      const { filtered_text } = await textRes.json();
      const userSpeech = filtered_text.toLowerCase().trim();

      const gptRes = await fetch(
        "https://www.d-rosa.ai/ChatgptOpenai",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ question: userSpeech }),
        }
      );

      const { answer } = await gptRes.json();

      setBotResponse(answer);
      setShowResponse(true);

      const ttsRes = await fetch(
        "https://www.d-rosa.ai/TXTSPECHAPI",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ text: answer }),
        }
      );

      const audioBlob2 = await ttsRes.blob();
      const audio = new Audio(URL.createObjectURL(audioBlob2));

      audio.onended = () => {
        recordedOnce.current = false;
        startAmplitudeMonitoring();
      };

      audio.play();
    } catch (e) {
      console.error("Voice Error:", e);
      recordedOnce.current = false;
      startAmplitudeMonitoring();
    }
  };

  useEffect(() => {
    if (!userEmail) navigate("/signin");
  }, [userEmail, navigate]);

  return (
    <div id="voice" className="screen">
      <div className="radar">
        <img src={blink} alt="Voice Active" />
      </div>

      {showResponse && botResponse && (
        <div className="neon-response">
          <div className="neon-inner">
            {botResponse.split("\n").map((line, i) => (
              <div key={i}>{line}</div>
            ))}
          </div>
        </div>
      )}

      {!finishedPhrases && (
        <h2 className={`fade-text ${fade ? "show" : "hide"}`}>
          {voicePhrases[index]}
        </h2>
      )}

      <button className="back-btn" onClick={() => navigate(-1)}>
        ? Back
      </button>
    </div>
  );
};

export default RosaChatgpt;